import { render } from "./AccessManager.html?vue&type=template&id=11c8a446&external"
import script from "./AccessManager.vue?vue&type=script&lang=js"
export * from "./AccessManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__